(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[436],{

/***/ 88680:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[category]/[slug]",
      function () {
        return __webpack_require__(61535);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(54300);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(24364);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(70619);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(83490);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(48482);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/link.js
var next_link = __webpack_require__(79894);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(88038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../node_modules/remark/index.js
var remark = __webpack_require__(74270);
var remark_default = /*#__PURE__*/__webpack_require__.n(remark);
// EXTERNAL MODULE: ../node_modules/remark-react/index.js
var remark_react = __webpack_require__(89499);
var remark_react_default = /*#__PURE__*/__webpack_require__.n(remark_react);
// EXTERNAL MODULE: ../node_modules/@lendi-ui/container/dist/container.esm.js + 2 modules
var container_esm = __webpack_require__(43151);
// EXTERNAL MODULE: ../node_modules/@lendi-ui/typography/dist/typography.esm.js + 2 modules
var typography_esm = __webpack_require__(87856);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(19989);
// EXTERNAL MODULE: ../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(30815);
// EXTERNAL MODULE: ../node_modules/@lendi-ui/icon/ChevronLeft/dist/icon.esm.js
var icon_esm = __webpack_require__(58641);
// EXTERNAL MODULE: ../node_modules/@lendi-ui/spacing/dist/spacing.esm.js + 1 modules
var spacing_esm = __webpack_require__(87646);
// EXTERNAL MODULE: ../node_modules/@lendi-ui/utils/dist/utils.esm.js
var utils_esm = __webpack_require__(71386);
// EXTERNAL MODULE: ./utils/index.ts + 13 modules
var utils = __webpack_require__(54422);
;// CONCATENATED MODULE: ./components/BackLink/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  display: inline-block;\n  text-decoration: none;\n  > * {\n    vertical-align: middle;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var StyledLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-34fb8769-0"
})(_templateObject(), (0,utils_esm/* display */.jf)({
    mobile: "none",
    desktop: "block"
}), (0,typography_esm/* link */.p4)({
    size: "sm"
}), (0,spacing_esm.my)("md"), (0,spacing_esm.px)("xxxs"));
var BackLink = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        as: "/inspire",
        href: "/",
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLink, {
            onClick: function() {
                (0,utils/* eventTracking */.fn)("above-fold", "navigate", "Back to Inspire Home");
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_esm/* default */.Z, {
                    color: "primary.500"
                }),
                " Back to Inspire Home"
            ]
        })
    });
};
/* harmony default export */ var components_BackLink = (BackLink);

// EXTERNAL MODULE: ../node_modules/@lendi-ui/breakpoint/dist/breakpoint.esm.js
var breakpoint_esm = __webpack_require__(66484);
// EXTERNAL MODULE: ../node_modules/@lendi-ui/button/dist/button.esm.js
var button_esm = __webpack_require__(95393);
;// CONCATENATED MODULE: ./components/ArticleCta/ArticleCta.tsx

function ArticleCta_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    align-items: center;\n  "
    ]);
    ArticleCta_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 1;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  width: auto;\n  height: 6rem;\n  flex: 0;\n  border-radius: 6px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  align-self: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: auto;\n    flex: 0;\n    white-space: nowrap;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  width: 100%;\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}









var CtaWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e28ace5b-0"
})(_templateObject1(), (0,utils_esm/* display */.jf)({
    mobile: "block",
    tablet: "inline-flex"
}), (0,breakpoint_esm/* gte */.eg)("tablet")(ArticleCta_templateObject()));
var CtaDetail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e28ace5b-1"
})(_templateObject3(), (0,breakpoint_esm/* gte */.eg)("tablet")(_templateObject2()));
var CtaImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-e28ace5b-2"
})(_templateObject4(), (0,spacing_esm.mr)("sm"));
var CtaText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e28ace5b-3"
})(_templateObject5());
var CtaButton = (0,styled_components_browser_esm/* default */.ZP)(button_esm/* Button */.zx).withConfig({
    componentId: "sc-e28ace5b-4"
})(_templateObject7(), (0,spacing_esm.mt)({
    mobile: "sm",
    tablet: "nil"
}), (0,spacing_esm.ml)({
    mobile: "nil",
    tablet: "sm"
}), (0,breakpoint_esm/* gte */.eg)("tablet")(_templateObject6()));
var ArticleCta = function(param) {
    var cta = param.cta, _showImage = param.showImage, showImage = _showImage === void 0 ? false : _showImage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CtaWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CtaDetail, {
                children: [
                    showImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaImage, {
                        src: cta.image
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CtaText, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_esm/* Heading */.X6, {
                                size: "sm",
                                color: "secondary.500",
                                children: cta.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_esm/* Body */.uT, {
                                children: cta.subTitle
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaButton, {
                variant: "primary",
                size: "sm",
                href: cta.url,
                onClick: function() {
                    (0,utils/* eventTracking */.fn)("above-fold", "navigate", cta.buttonText);
                },
                children: cta.buttonText
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/ArticleCta/BottomCta.tsx

function BottomCta_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  max-width: ",
        ";\n"
    ]);
    BottomCta_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b2133323-0"
})(BottomCta_templateObject(), (0,spacing_esm.py)("lg"), (0,spacing_esm.px)({
    mobile: "md",
    desktop: "xxs"
}), (0,spacing_esm.mx)("auto"), function(param) {
    var showImage = param.showImage;
    return showImage ? "48rem" : "40rem";
});
var BottomCta = function(param) {
    var ctas = param.ctas, _showImage = param.showImage, showImage = _showImage === void 0 ? false : _showImage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        showImage: showImage,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(container_esm/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCta, {
                cta: ctas[0],
                showImage: showImage
            })
        })
    });
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(52050);
// EXTERNAL MODULE: ../node_modules/@lendi-ui/color/dist/color.esm.js
var color_esm = __webpack_require__(78922);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(9722);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/numeral/numeral.js
var numeral = __webpack_require__(94960);
// EXTERNAL MODULE: ../node_modules/@lendi-ui/field/dist/field.esm.js + 8 modules
var field_esm = __webpack_require__(24719);
// EXTERNAL MODULE: ../node_modules/@lendi-ui/icon/KeyboardArrowLeft/dist/icon.esm.js
var dist_icon_esm = __webpack_require__(28498);
// EXTERNAL MODULE: ../node_modules/@lendi-ui/icon/Message/dist/icon.esm.js
var Message_dist_icon_esm = __webpack_require__(26629);
// EXTERNAL MODULE: ../node_modules/@lendi-ui/icon/Calendar/dist/icon.esm.js
var Calendar_dist_icon_esm = __webpack_require__(25754);
// EXTERNAL MODULE: ../node_modules/@lendi-ui/text-input/dist/text-input.esm.js + 1 modules
var text_input_esm = __webpack_require__(89661);
// EXTERNAL MODULE: ../node_modules/@lendi/chat/dist/esm/providers/ChatBootstrapperProvider/context.js
var context = __webpack_require__(84358);
// EXTERNAL MODULE: ../node_modules/@lendi-ui/depth/dist/depth.esm.js
var depth_esm = __webpack_require__(83674);
;// CONCATENATED MODULE: ./components/Widgets/index.style.ts

function index_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  border-radius: 6px;\n"
    ]);
    index_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function index_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    index_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function index_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    align-items: flex-end;\n  "
    ]);
    index_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function index_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  margin-left: calc(-0.5 * var(--lendi-ui-size));\n  margin-right: calc(-0.5 * var(--lendi-ui-size));\n  ",
        "\n  > * {\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    index_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function index_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  ",
        "\n  ",
        "\n  > span {\n    display: inline-block;\n    ",
        "\n  }\n"
    ]);
    index_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function index_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    index_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function index_style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  text-decoration: none;\n"
    ]);
    index_style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function index_style_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: nowrap;\n"
    ]);
    index_style_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  float: right;\n  border: none;\n  background: none;\n  text-decoration: none;\n  > * {\n    ",
        "\n    vertical-align: top;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  clear: both;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 0;\n    min-width: 19rem;\n    border-bottom: none;\n    border-right: 1px solid ",
        ";\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-width: 21rem;\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  border-bottom: 1px solid ",
        ";\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  display: flex;\n  justify-content: space-evenly;\n\n  a,\n  button {\n    background: none;\n    border: none;\n    span {\n      vertical-align: middle;\n    }\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}








var index_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-87bdbe16-0"
})(index_style_templateObject(), (0,spacing_esm.my)("md"), (0,spacing_esm.p)("md"), (0,spacing_esm.pb)("sm"), (0,color_esm.bg)("secondary.25"), (0,depth_esm/* depth */.Y)(1));
var Title = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-87bdbe16-1"
})(index_style_templateObject1(), (0,typography_esm/* heading */.nP)({
    size: "sm",
    color: "secondary.500"
}), (0,spacing_esm.mt)("nil"), (0,spacing_esm.mb)("sm"));
var InputGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-87bdbe16-2"
})(index_style_templateObject3(), (0,utils_esm/* display */.jf)({
    mobile: "block",
    tablet: "flex"
}), (0,spacing_esm.my)("nil"), (0,breakpoint_esm/* gte */.eg)("tablet")(index_style_templateObject2()), (0,spacing_esm.mx)("xxs"), (0,spacing_esm.mb)("sm"));
var Label = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-87bdbe16-3"
})(index_style_templateObject4(), (0,spacing_esm.mx)("xxs"), (0,spacing_esm.mb)("sm"), (0,spacing_esm.mb)("xxxs"));
var InputExtra = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-87bdbe16-4"
})(index_style_templateObject5(), function(param) {
    var side = param.side;
    return (0,spacing_esm.ml)(side === "left" ? "xs" : "xxxs");
}, function(param) {
    var side = param.side;
    return (0,spacing_esm.mr)(side === "left" ? "xxxs" : "xs");
});
var PropertyReportLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-87bdbe16-5"
})(index_style_templateObject6(), (0,typography_esm/* link */.p4)());
var CalculateButton = (0,styled_components_browser_esm/* default */.ZP)(button_esm/* Button */.zx).withConfig({
    componentId: "sc-87bdbe16-6"
})(index_style_templateObject7());
var ResetButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-87bdbe16-7"
})(_templateObject8(), (0,typography_esm/* link */.p4)({
    size: "md",
    color: "primary.500"
}), (0,spacing_esm.mb)("xxs"), (0,spacing_esm.mt)("xxxs"));
var ResultsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-87bdbe16-8"
})(_templateObject9(), (0,utils_esm/* display */.jf)({
    mobile: "block",
    tablet: "flex"
}));
var QuoteSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-87bdbe16-9"
})(_templateObject12(), (0,spacing_esm.pb)({
    mobile: "md",
    tablet: "nil"
}), (0,spacing_esm.pr)({
    mobile: "nil",
    tablet: "sm",
    desktop: "md"
}), (0,color_esm/* color */.$)("shade.100"), (0,breakpoint_esm/* gte */.eg)("tablet")(_templateObject10(), "".concat((0,color_esm/* color */.$)("shade.100"))), (0,breakpoint_esm/* gte */.eg)("desktop")(_templateObject11()));
var QuoteAmount = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-87bdbe16-10"
})(_templateObject13(), (0,typography_esm/* heading */.nP)({
    size: "xl",
    color: "primary.700"
}));
var QuotePeriod = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-87bdbe16-11"
})(_templateObject14(), (0,typography_esm/* body */.d1)({
    size: "lg",
    color: "shade.500"
}), (0,spacing_esm.ml)("xxs"));
var CtaSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-87bdbe16-12"
})(_templateObject15(), (0,spacing_esm.pt)({
    mobile: "md",
    tablet: "nil"
}), (0,spacing_esm.pl)({
    mobile: "nil",
    tablet: "sm",
    desktop: "md"
}));
var MoreCtas = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-87bdbe16-13"
})(_templateObject16(), (0,spacing_esm.mt)("sm"));

;// CONCATENATED MODULE: ./components/Widgets/EquityCalculator.tsx




function EquityCalculator_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 16rem;\n"
    ]);
    EquityCalculator_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var CalculateEquityButton = (0,styled_components_browser_esm/* default */.ZP)(CalculateButton).withConfig({
    componentId: "sc-a395f739-0"
})(EquityCalculator_templateObject());
var InputsView = function(param) {
    var propertyValue = param.propertyValue, outstandingLoanAmount = param.outstandingLoanAmount, calculateEquity = param.calculateEquity;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: function(e) {
            e.preventDefault();
            calculateEquity();
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: "How much equity can you access?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputGroup, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(field_esm/* default */.Z, {
                        size: "sm",
                        label: "My property is worth approximately",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_input_esm/* Input */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, propertyValue), {
                            before: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputExtra, {
                                side: "left",
                                children: "$"
                            }),
                            isFullWidth: true
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography_esm/* Body */.uT, {
                        size: "md",
                        style: {
                            minWidth: "16rem"
                        },
                        children: [
                            "Don't know your property value?",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PropertyReportLink, {
                                href: "/property-report",
                                onClick: function() {
                                    (0,utils/* eventTracking */.fn)("above-fold", "navigate", "Get a free property report");
                                },
                                children: "Get a free property report"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputGroup, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(field_esm/* default */.Z, {
                        size: "sm",
                        label: "Outstanding home loan amount",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_input_esm/* Input */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, outstandingLoanAmount), {
                            before: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputExtra, {
                                side: "left",
                                children: "$"
                            }),
                            isFullWidth: true
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CalculateEquityButton, {
                        type: "submit",
                        variant: "primary",
                        isDisabled: propertyValue.value === "0" || outstandingLoanAmount.value === "0.0",
                        onClick: function() {
                            (0,utils/* eventTracking */.fn)("above-fold", "navigate", "Calculate equity");
                        },
                        children: "Calculate equity"
                    })
                ]
            })
        ]
    });
};
var ResultsView = function(param) {
    var accessibleEquityLimit = param.accessibleEquityLimit, monthlyRepayment = param.monthlyRepayment, interestRate = param.interestRate, loanTerm = param.loanTerm, resetCalculator = param.resetCalculator;
    var openChat = (0,context/* useBootstrappedChatState */.D)().openChat;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResetButton, {
                onClick: resetCalculator,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_icon_esm/* default */.Z, {
                        color: "primary.500"
                    }),
                    " Start again"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResultsWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuoteSection, {
                        style: {
                            minWidth: "22rem"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: "You could access up to"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuoteAmount, {
                                children: [
                                    "$ ",
                                    accessibleEquityLimit.format()
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_esm/* Heading */.X6, {
                                size: "xs",
                                mt: "sm",
                                mb: "xxs",
                                children: "Your new repayments could be"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuoteAmount, {
                                children: [
                                    "$ ",
                                    monthlyRepayment.format()
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuotePeriod, {
                                children: "/ month"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography_esm/* Body */.uT, {
                                size: "sm",
                                mt: "xs",
                                children: [
                                    "At a variable rate of ",
                                    interestRate.format("0.00"),
                                    "% on a loan term of ",
                                    loanTerm.format(),
                                    " years"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography_esm/* Body */.uT, {
                                size: "xs",
                                mt: "md",
                                color: "shade.500",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Disclaimer:"
                                    }),
                                    " While every effort has been made to ensure the accuracy of this calculator, the actual results may vary depending on a variety of factors. This result is an indication only."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CtaSection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_esm/* Heading */.X6, {
                                size: "xs",
                                mt: "nil",
                                mb: "xs",
                                children: "Find out which cash out loans you could qualify for in 30 seconds"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_esm/* Body */.uT, {
                                size: "sm",
                                mb: "md",
                                children: "Choose from over 30 major lenders and get approved quickly and easy."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_esm/* Button */.zx, {
                                variant: "primary",
                                isFullWidth: true,
                                href: "/home-loans/search",
                                onClick: function() {
                                    (0,utils/* eventTracking */.fn)("above-fold", "navigate", "Compare now");
                                },
                                children: "Compare now"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MoreCtas, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_esm/* Button */.zx, {
                                        variant: "empty",
                                        size: "sm",
                                        onClick: function() {
                                            openChat();
                                            (0,utils/* eventTracking */.fn)("above-fold", "navigate", "Chat now");
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Message_dist_icon_esm/* default */.Z, {
                                                color: "primary.500"
                                            }),
                                            " Chat now"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_esm/* Button */.zx, {
                                        variant: "empty",
                                        size: "sm",
                                        href: "/appointment-booking/postcode",
                                        onClick: function() {
                                            (0,utils/* eventTracking */.fn)("above-fold", "navigate", "Book an appointment");
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Calendar_dist_icon_esm/* default */.Z, {
                                                color: "primary.500"
                                            }),
                                            " Book an appointment"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var EquityCalculator = function() {
    var resetCalculator = function resetCalculator() {
        propertyValue.update(numeral(1000000));
        outstandingLoanAmount.update(numeral(400000));
        setAccessibleEquityLimit(0);
        setMonthlyRepayment(0);
        setIsResultsView(false);
    };
    var calculateEquity = function calculateEquity() {
        // Calculate the accesible equity value
        var equityValue = (0,utils/* calculateEquityValue */.zY)(propertyValue.value.value());
        var accessibleEquityLimit = (0,utils/* calculateAccessibleEquityValue */.$c)(outstandingLoanAmount.value.value(), equityValue);
        setAccessibleEquityLimit(accessibleEquityLimit);
        // Calculate principal and interest monthly payment
        var newLoanAmount = outstandingLoanAmount.value.value() + accessibleEquityLimit;
        setMonthlyRepayment((0,utils/* calculatePrincipalInterestMonthlyRepayment */.uw)(newLoanAmount, interestRate, loanTerm));
        setIsResultsView(true);
    };
    var propertyValue = (0,utils/* useTextInput */.r6)(numeral(1000000), numeral, function(v) {
        return v.format();
    });
    var outstandingLoanAmount = (0,utils/* useTextInput */.r6)(numeral(400000), numeral, function(v) {
        return v.format();
    });
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), accessibleEquityLimit = ref[0], setAccessibleEquityLimit = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), monthlyRepayment = ref1[0], setMonthlyRepayment = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isResultsView = ref2[0], setIsResultsView = ref2[1];
    var interestRate = 3.69;
    var loanTerm = 25;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_style_Wrapper, {
        children: isResultsView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultsView, {
            accessibleEquityLimit: numeral(accessibleEquityLimit),
            monthlyRepayment: numeral(monthlyRepayment),
            interestRate: numeral(interestRate),
            loanTerm: numeral(loanTerm),
            resetCalculator: resetCalculator
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(InputsView, {
            propertyValue: propertyValue.inputAttrs,
            outstandingLoanAmount: outstandingLoanAmount.inputAttrs,
            calculateEquity: calculateEquity
        })
    });
};

;// CONCATENATED MODULE: ./components/Widgets/HomeLoanRepaymentCalculator.tsx














var HomeLoanRepaymentCalculator_InputsView = function(param) {
    var loanAmount = param.loanAmount, interestRate = param.interestRate, loanTerm = param.loanTerm, interestOnlyPeriod = param.interestOnlyPeriod, _isInterestOnly = param.isInterestOnly, isInterestOnly = _isInterestOnly.isInterestOnly, setIsInterestOnly = _isInterestOnly.setIsInterestOnly, calculateMonthlyRepayment = param.calculateMonthlyRepayment;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: function(e) {
            e.preventDefault();
            calculateMonthlyRepayment();
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: "Calculate your loan repayments"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputGroup, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(field_esm/* default */.Z, {
                        size: "sm",
                        label: "How much do you want to borrow?",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_input_esm/* Input */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, loanAmount), {
                            before: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputExtra, {
                                side: "left",
                                children: "$"
                            }),
                            isFullWidth: true
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(field_esm/* default */.Z, {
                        size: "sm",
                        label: "With an interest rate of",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_input_esm/* Input */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, interestRate), {
                            after: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputExtra, {
                                side: "right",
                                children: "%"
                            }),
                            isFullWidth: true
                        }))
                    }),
                    isInterestOnly ? /*#__PURE__*/ (0,jsx_runtime.jsx)(field_esm/* default */.Z, {
                        size: "sm",
                        label: "Interest only period",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_input_esm/* Input */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, interestOnlyPeriod), {
                            after: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputExtra, {
                                side: "right",
                                children: "years"
                            }),
                            isFullWidth: true
                        }))
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(field_esm/* default */.Z, {
                        size: "sm",
                        label: "Over a loan term of",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_input_esm/* Input */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, loanTerm), {
                            after: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputExtra, {
                                side: "right",
                                children: "years"
                            }),
                            isFullWidth: true
                        }))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputGroup, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(field_esm/* default */.Z, {
                        size: "sm",
                        label: "Repayment type",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "radio",
                                            value: "principalAndInterest",
                                            checked: !isInterestOnly,
                                            onChange: function() {
                                                return setIsInterestOnly(false);
                                            }
                                        }),
                                        " ",
                                        "Principal & interest"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "radio",
                                            value: "interestOnly",
                                            checked: isInterestOnly,
                                            onChange: function() {
                                                return setIsInterestOnly(true);
                                            }
                                        }),
                                        " ",
                                        "Interest only"
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CalculateButton, {
                        type: "submit",
                        variant: "primary",
                        onClick: function() {
                            (0,utils/* eventTracking */.fn)("above-fold", "navigate", "Calculate loan payment");
                        },
                        isDisabled: loanAmount.value === "0" || interestRate.value === "0.0" || isInterestOnly && interestOnlyPeriod.value === "0" || !isInterestOnly && loanTerm.value === "0",
                        children: "Calculate loan payment"
                    })
                ]
            })
        ]
    });
};
var HomeLoanRepaymentCalculator_ResultsView = function(param) {
    var monthlyRepayment = param.monthlyRepayment, interestRate = param.interestRate, loanTerm = param.loanTerm, interestOnlyPeriod = param.interestOnlyPeriod, isInterestOnly = param.isInterestOnly, resetCalculator = param.resetCalculator;
    var openChat = (0,context/* useBootstrappedChatState */.D)().openChat;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResetButton, {
                onClick: resetCalculator,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_icon_esm/* default */.Z, {
                        color: "primary.500"
                    }),
                    " Start again"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResultsWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuoteSection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: "Your repayments could be"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuoteAmount, {
                                children: [
                                    "$ ",
                                    monthlyRepayment.format()
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuotePeriod, {
                                children: "/ month"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography_esm/* Body */.uT, {
                                size: "sm",
                                mt: "xs",
                                children: [
                                    "At an interest rate of ",
                                    interestRate.format("0.00"),
                                    "% over",
                                    " ",
                                    isInterestOnly ? interestOnlyPeriod.format() : loanTerm.format(),
                                    " years"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography_esm/* Body */.uT, {
                                size: "xs",
                                mt: "lg",
                                color: "shade.500",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Disclaimer:"
                                    }),
                                    " While every effort has been made to ensure the accuracy of this calculator, the actual results may vary depending on a variety of factors. This result is an indication only."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CtaSection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_esm/* Heading */.X6, {
                                size: "xs",
                                mt: "nil",
                                mb: "xs",
                                children: "Want to pay less each month on your home loan?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_esm/* Body */.uT, {
                                size: "sm",
                                mb: "md",
                                children: "We search through thousands of home loans to find the right one for you."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_esm/* Button */.zx, {
                                variant: "primary",
                                isFullWidth: true,
                                href: "/home-loans/search",
                                onClick: function() {
                                    (0,utils/* eventTracking */.fn)("above-fold", "navigate", "Find a home loan now");
                                },
                                children: "Find a home loan now"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MoreCtas, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_esm/* Button */.zx, {
                                        variant: "empty",
                                        size: "sm",
                                        onClick: function() {
                                            openChat();
                                            (0,utils/* eventTracking */.fn)("above-fold", "navigate", "Chat now");
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Message_dist_icon_esm/* default */.Z, {
                                                color: "primary.500"
                                            }),
                                            " Chat now"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_esm/* Button */.zx, {
                                        variant: "empty",
                                        size: "sm",
                                        href: "/appointment-booking/postcode",
                                        onClick: function() {
                                            (0,utils/* eventTracking */.fn)("above-fold", "navigate", "Book an appointment");
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Calendar_dist_icon_esm/* default */.Z, {
                                                color: "primary.500"
                                            }),
                                            " Book an appointment"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var HomeLoanRepaymentCalculator = function() {
    var calculateMonthlyRepayment = function calculateMonthlyRepayment() {
        setMonthlyRepayment(isInterestOnly ? (0,utils/* calculateInterestOnlyMonthlyRepayment */.Kh)(loanAmount.value.value(), interestRate.value.value()) : (0,utils/* calculatePrincipalInterestMonthlyRepayment */.uw)(loanAmount.value.value(), interestRate.value.value(), loanTerm.value.value()));
        setIsResultsView(true);
    };
    var resetCalculator = function resetCalculator() {
        loanAmount.update(numeral(350000));
        interestRate.update(numeral(3.69));
        loanTerm.update(numeral(30));
        interestOnlyPeriod.update(numeral(1));
        setIsInterestOnly(false);
        setIsResultsView(false);
        setMonthlyRepayment(0);
    };
    var loanAmount = (0,utils/* useTextInput */.r6)(numeral(350000), numeral, function(v) {
        return v.format();
    });
    var interestRate = (0,utils/* useTextInput */.r6)(numeral(3.69), numeral, function(v) {
        return v.format("0.00");
    });
    var loanTerm = (0,utils/* useTextInput */.r6)(numeral(30), numeral, function(v) {
        return v.format();
    });
    var interestOnlyPeriod = (0,utils/* useTextInput */.r6)(numeral(1), numeral, function(v) {
        return v.format();
    });
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isInterestOnly = ref[0], setIsInterestOnly = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isResultsView = ref1[0], setIsResultsView = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), monthlyRepayment = ref2[0], setMonthlyRepayment = ref2[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_style_Wrapper, {
        children: isResultsView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeLoanRepaymentCalculator_ResultsView, {
            monthlyRepayment: numeral(monthlyRepayment),
            interestRate: interestRate.value,
            loanTerm: loanTerm.value,
            interestOnlyPeriod: interestOnlyPeriod.value,
            isInterestOnly: isInterestOnly,
            resetCalculator: resetCalculator
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeLoanRepaymentCalculator_InputsView, {
            loanAmount: loanAmount.inputAttrs,
            interestRate: interestRate.inputAttrs,
            loanTerm: loanTerm.inputAttrs,
            interestOnlyPeriod: interestOnlyPeriod.inputAttrs,
            isInterestOnly: {
                isInterestOnly: isInterestOnly,
                setIsInterestOnly: setIsInterestOnly
            },
            calculateMonthlyRepayment: calculateMonthlyRepayment
        })
    });
};

;// CONCATENATED MODULE: ./components/Widgets/index.tsx



;// CONCATENATED MODULE: ./components/ArticleCta/InlineCta.tsx


function InlineCta_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  border-top: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    InlineCta_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var InlineCtaWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3265b47b-0"
})(InlineCta_templateObject(), (0,spacing_esm.my)("md"), (0,spacing_esm.py)("md"), (0,spacing_esm.px)("xxs"), (0,color_esm/* color */.$)("shade.100"), (0,color_esm/* color */.$)("shade.100"));
var InlineCtaHOC = function(ctas) {
    return /*#__PURE__*/ react.memo(function(param) {
        var children = param.children;
        var _children = (0,_sliced_to_array/* default */.Z)(children, 1), firstChild = _children[0];
        // Find and show widgets
        if (typeof firstChild === "string" && firstChild.trim().match(/^%%___widget\s.*%%$/i)) {
            var widgetTitle = firstChild.trim().toLowerCase().replace(/(^%%___widget\s|%%$)/g, "");
            switch(widgetTitle){
                case "equity":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EquityCalculator, {});
                case "home-loan-repayment":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeLoanRepaymentCalculator, {});
            }
        }
        // Find and show Cta's
        if (typeof firstChild === "string" && firstChild.trim().match(/^%%.*%%$/)) {
            var ctaTitle = firstChild.trim().toLowerCase().replace(/(^%%|%%$)/g, "");
            var cta = ctas.find(function(cta) {
                return ctaTitle === cta.title.toLowerCase();
            });
            if (cta) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineCtaWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCta, {
                        cta: cta
                    })
                });
            }
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_esm/* Body */.uT, {
            size: "md",
            my: "md",
            children: children
        });
    });
};

;// CONCATENATED MODULE: ./components/ArticleCta/index.tsx




;// CONCATENATED MODULE: ./components/ArticleTags/index.style.ts

function ArticleTags_index_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ArticleTags_index_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ArticleTags_index_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  font-weight: normal;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  text-decoration: none;\n  :active {\n    text-decoration: none;\n  }\n"
    ]);
    ArticleTags_index_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var TagsWrapper = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-434ac854-0"
})(ArticleTags_index_style_templateObject(), (0,typography_esm/* body */.d1)({
    size: "xs"
}), (0,spacing_esm.my)("md"));
var Alink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-434ac854-1"
})(ArticleTags_index_style_templateObject1(), (0,typography_esm/* link */.p4)({
    size: "xs",
    color: "primary.500"
}), (0,spacing_esm.ml)("xxxs"));

;// CONCATENATED MODULE: ./components/ArticleTags/index.tsx




var ArticleTags = function(param) {
    var tags = param.tags;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TagsWrapper, {
        children: [
            "Tags:",
            " ",
            tags.map(function(tag, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            as: "/inspire/tag/".concat(tag.slug),
                            href: "/tag?tag=".concat(tag.slug),
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alink, {
                                target: "_blank",
                                children: tag.name
                            })
                        }),
                        index < tags.length - 1 ? ", " : ""
                    ]
                }, tag.id);
            })
        ]
    });
};
/* harmony default export */ var components_ArticleTags = (ArticleTags);

// EXTERNAL MODULE: ./components/ArticleCard/index.tsx
var ArticleCard = __webpack_require__(95622);
// EXTERNAL MODULE: ./components/ArticleCard/index.style.ts
var index_style = __webpack_require__(27057);
;// CONCATENATED MODULE: ./components/ArticleScroller/index.ts

function ArticleScroller_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  overflow-x: auto;\n"
    ]);
    ArticleScroller_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ArticleScroller_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  min-width: 100%;\n\n  ",
        " {\n    width: 50%;\n    min-width: 16rem;\n    border: none;\n    ",
        "\n    ",
        "\n    &:first-child {\n      ",
        "\n    }\n\n    ",
        " {\n      height: 30vw;\n      min-height: 9rem;\n      max-height: 21rem;\n    }\n  }\n"
    ]);
    ArticleScroller_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var ArticleScrollWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5954d4e2-0"
})(ArticleScroller_templateObject());
var ArticleScroller = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5954d4e2-1"
})(ArticleScroller_templateObject1(), index_style/* Article */.d2, (0,spacing_esm.mb)("xs"), (0,spacing_esm.ml)("sm"), (0,spacing_esm.ml)("nil"), index_style/* FigureLink */.Qw);

;// CONCATENATED MODULE: ./components/ReadMoreArticles/index.style.ts

function ReadMoreArticles_index_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  border-top: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n  img {\n    max-width: 100%;\n  }\n"
    ]);
    ReadMoreArticles_index_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ReadMoreArticles_index_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ReadMoreArticles_index_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var ReadMoreArticles_index_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-57b1af7f-0"
})(ReadMoreArticles_index_style_templateObject(), (0,spacing_esm.mx)({
    mobile: "md",
    desktop: "xxs"
}), (0,spacing_esm.py)("lg"), (0,color_esm/* color */.$)("shade.100"), (0,color_esm/* color */.$)("shade.100"));
var index_style_Title = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-57b1af7f-1"
})(ReadMoreArticles_index_style_templateObject1(), (0,typography_esm/* heading */.nP)({
    size: "sm",
    color: "secondary.500"
}), (0,spacing_esm.mt)("nil"), (0,spacing_esm.mb)("sm"));

;// CONCATENATED MODULE: ./components/ReadMoreArticles/index.tsx





var ReadMoreArticles = function(param) {
    var articles = param.articles;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReadMoreArticles_index_style_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_style_Title, {
                children: "Read more"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleScrollWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleScroller, {
                    children: articles.map(function(article) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCard/* default */.Z, {
                            article: article,
                            showSummary: false
                        }, article.id);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_ReadMoreArticles = (ReadMoreArticles);

;// CONCATENATED MODULE: ./components/RelatedArticles/index.style.ts

function RelatedArticles_index_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    RelatedArticles_index_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RelatedArticles_index_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        " ",
        " {\n    height: 10rem;\n  }\n"
    ]);
    RelatedArticles_index_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RelatedArticles_index_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    RelatedArticles_index_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var OuterWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c5e5c927-0"
})(RelatedArticles_index_style_templateObject(), (0,spacing_esm.py)("lg"), (0,color_esm.bg)("secondary.25"));
var InnerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c5e5c927-1"
})(RelatedArticles_index_style_templateObject1(), (0,spacing_esm.mx)({
    mobile: "md",
    desktop: "xxs"
}), index_style/* Article */.d2, index_style/* FigureLink */.Qw);
var RelatedArticles_index_style_Title = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-c5e5c927-2"
})(RelatedArticles_index_style_templateObject2(), (0,typography_esm/* heading */.nP)({
    size: "sm",
    color: "secondary.500"
}), (0,spacing_esm.mt)("nil"), (0,spacing_esm.mb)("sm"));

;// CONCATENATED MODULE: ./components/RelatedArticles/index.tsx






var RelatedArticles = function(param) {
    var articles = param.articles;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OuterWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(container_esm/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InnerWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedArticles_index_style_Title, {
                        children: "Related articles"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleScrollWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleScroller, {
                            children: articles.map(function(article) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCard/* default */.Z, {
                                    article: article,
                                    showSummary: false
                                }, article.id);
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_RelatedArticles = (RelatedArticles);

;// CONCATENATED MODULE: ./components/ArticlePrimaryVideo/index.style.ts

function ArticlePrimaryVideo_index_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  height: 50vw;\n  max-height: 27rem;\n"
    ]);
    ArticlePrimaryVideo_index_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ArticlePrimaryVideo_index_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n"
    ]);
    ArticlePrimaryVideo_index_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ArticlePrimaryVideo_index_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n"
    ]);
    ArticlePrimaryVideo_index_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var Figure = styled_components_browser_esm/* default.figure.withConfig */.ZP.figure.withConfig({
    componentId: "sc-cd990318-0"
})(ArticlePrimaryVideo_index_style_templateObject(), (0,spacing_esm.mx)("nil"), (0,spacing_esm.my)("md"));
var Video = styled_components_browser_esm/* default.video.withConfig */.ZP.video.withConfig({
    componentId: "sc-cd990318-1"
})(ArticlePrimaryVideo_index_style_templateObject1());
var Iframe = styled_components_browser_esm/* default.iframe.withConfig */.ZP.iframe.withConfig({
    componentId: "sc-cd990318-2"
})(ArticlePrimaryVideo_index_style_templateObject2());

;// CONCATENATED MODULE: ./components/ArticlePrimaryVideo/index.tsx




var VIDEO_EXTENSIONS = [
    "webm",
    "ogg",
    "mp4",
    "mkv",
    "flv",
    "vob",
    "gif",
    "gifv",
    "avi",
    "wmv"
];
var ArticlePrimaryVideo = function(param) {
    var src = param.src, caption = param.caption;
    var isVideoFile = VIDEO_EXTENSIONS.some(function(extension) {
        return src.endsWith(extension);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Figure, {
        onClick: function() {
            (0,utils/* eventTracking */.fn)("above-fold", "navigate", "video");
        },
        children: [
            isVideoFile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Video, {
                src: src,
                controls: true
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Iframe, {
                src: src,
                frameBorder: "0",
                allowFullScreen: true
            }),
            caption && /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                children: caption
            })
        ]
    });
};
/* harmony default export */ var components_ArticlePrimaryVideo = (ArticlePrimaryVideo);

// EXTERNAL MODULE: ./components/Drawer/index.style.ts
var Drawer_index_style = __webpack_require__(21593);
// EXTERNAL MODULE: ../node_modules/next/config.js
var config = __webpack_require__(23892);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./components/Drawer/index.tsx






var title = "Is your low fixed rate coming to an end?";
var publicRuntimeConfig = config_default()().publicRuntimeConfig;
var Drawer = function(param) {
    var show = param.show, toggleDrawer = param.toggleDrawer;
    var ASSET_PREFIX = publicRuntimeConfig.ASSET_PREFIX;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer_index_style/* Wrapper */.im, {
        show: show,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_index_style/* DownIcon */.KL, {
                color: "shade.0",
                onClick: toggleDrawer
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_index_style/* PreviewTitle */.X2, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer_index_style/* Container */.W2, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_index_style/* Image */.Ee, {
                        src: "".concat(ASSET_PREFIX, "images/image.jpg"),
                        srcSet: "".concat("".concat(ASSET_PREFIX, "images/image.jpg"), " 1x, ").concat("".concat(ASSET_PREFIX, "images/image@2x.jpg"), " 2x")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer_index_style/* Content */.VY, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_index_style/* Heading */.X6, {
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_index_style/* Paragraph */.nv, {
                                children: "Search competitive rates in minutes and find the right one for you."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_esm/* Button */.zx, {
                                variant: "emphasis",
                                size: "sm",
                                onClick: function() {
                                    (0,utils/* eventTracking */.fn)("above-fold", "navigate", "Compare rates");
                                    window.location.href = "/home-loans/basics/refinance/loan-amount" + window.location.search;
                                },
                                children: "Compare rates"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Drawer = (Drawer);

// EXTERNAL MODULE: ./components/Article/index.style.ts
var Article_index_style = __webpack_require__(78934);
;// CONCATENATED MODULE: ./pages/[category]/[slug].tsx























var NUMBER_OF_RELATED_ARTICLES = 4;
var ArticlePage = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ArticlePage, _Component);
    var _super = (0,_create_super/* default */.Z)(ArticlePage);
    function ArticlePage() {
        (0,_class_call_check/* default */.Z)(this, ArticlePage);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            relatedArticles: [],
            readMoreArticles: [],
            showDrawer: false
        };
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.componentDidMount = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var relatedArticles, readMoreArticles;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,utils/* loadArticles */.nw)({
                                category: _this1.props.category,
                                exclude: _this1.props.article,
                                limit: NUMBER_OF_RELATED_ARTICLES
                            })
                        ];
                    case 1:
                        relatedArticles = _state.sent();
                        _this1.setState({
                            relatedArticles: relatedArticles
                        });
                        return [
                            4,
                            (0,utils/* loadReadMoreArticles */.IV)(_this1.props.article, relatedArticles)
                        ];
                    case 2:
                        readMoreArticles = _state.sent();
                        _this1.setState({
                            readMoreArticles: readMoreArticles
                        });
                        window.setTimeout(function() {
                            return _this1.setState({
                                showDrawer: true
                            });
                        }, 10000);
                        return [
                            2
                        ];
                }
            });
        });
        _this.toggleDrawer = function() {
            _this.setState(function(prevState) {
                (0,utils/* eventTracking */.fn)("above-fold", !prevState.showDrawer ? "open" : "cancel", "icon");
                return {
                    showDrawer: !prevState.showDrawer
                };
            });
        };
        return _this;
    }
    var _proto = ArticlePage.prototype;
    _proto.render = function render() {
        var _state = this.state, relatedArticles = _state.relatedArticles, readMoreArticles = _state.readMoreArticles, showDrawer = _state.showDrawer;
        var article = this.props.article;
        var title = article.title, author = article.author, _category = article.category, category = _category.name, categorySlug = _category.slug, tags = article.tags, published = article.published, formattedPublished = article.formattedPublished, meta = article.meta, primaryImage = article.primaryImage, primaryVideo = article.primaryVideo, primaryVideoCaption = article.primaryVideoCaption, content = article.content, readTime = article.readTime, navigationCtas = article.navigationCtas, bottomCtas = article.bottomCtas;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(container_esm/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                                    children: [
                                        title,
                                        " - Lendi"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    name: "description",
                                    content: meta.description
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    property: "og:type",
                                    content: "article"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    property: "og:title",
                                    content: meta.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    property: "og:description",
                                    content: meta.description
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    property: "og:image",
                                    content: "https:".concat(primaryImage)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    property: "og:url",
                                    content: (0,utils/* articleUrl */.MG)(article)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    name: "twitter:title",
                                    content: meta.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    name: "twitter:description",
                                    content: meta.description
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    name: "twitter:image",
                                    content: "https:".concat(primaryImage)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    name: "twitter:creator",
                                    content: "@lendiau"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                    rel: "canonical",
                                    href: (0,utils/* articleUrl */.MG)(article)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BackLink, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Article_index_style/* ArticleWrapper */.DO, {
                            itemScope: true,
                            itemType: "http://schema.org/Article",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    itemProp: "datePublished",
                                    content: published
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    itemProp: "url",
                                    content: (0,utils/* articleUrl */.MG)(article)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    itemProp: "mainEntityOfPage",
                                    content: (0,utils/* articleUrl */.MG)(article)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    itemProp: "name",
                                    content: meta.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    itemProp: "headline",
                                    content: meta.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    as: "/inspire/category/".concat(categorySlug),
                                    href: "/?category=".concat(categorySlug),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Article_index_style/* ArticleCategoryLink */.es, {
                                        target: "_blank",
                                        onClick: function() {
                                            (0,utils/* eventTracking */.fn)("above-fold", "navigate", category);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Article_index_style/* ArticleCategory */.Fo, {
                                            children: category
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Article_index_style/* ArticleTitle */.j1, {
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Article_index_style/* ArticleInfo */.dg, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Article_index_style/* AuthorInfo */.d7, {
                                            children: [
                                                "By ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Article_index_style/* AuthorName */.U2, {
                                                    itemProp: "author",
                                                    children: author
                                                }),
                                                ","
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                            dateTime: published,
                                            itemProp: "datePublished",
                                            children: formattedPublished
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Article_index_style/* ReadTimeInfo */.rb, {
                                            children: [
                                                "| ",
                                                readTime,
                                                " min read"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Article_index_style/* ArticlePrimaryImage */.tt, {
                                    src: primaryImage
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Article_index_style/* ArticleBody */.Ml, {
                                    children: remark_default()().use((remark_react_default()), {
                                        remarkReactComponents: {
                                            a: typography_esm/* Link */.rU,
                                            ul: Article_index_style.Ul,
                                            p: InlineCtaHOC(article.contentCtas),
                                            table: Article_index_style/* Table */.iA
                                        }
                                    }).processSync(content).contents
                                }),
                                primaryVideo && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ArticlePrimaryVideo, {
                                    src: primaryVideo,
                                    caption: primaryVideoCaption
                                }),
                                tags.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ArticleTags, {
                                    tags: tags
                                })
                            ]
                        }),
                        readMoreArticles.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ReadMoreArticles, {
                            articles: readMoreArticles
                        })
                    ]
                }),
                navigationCtas.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomCta, {
                    ctas: navigationCtas,
                    showImage: true
                }),
                relatedArticles.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RelatedArticles, {
                    articles: relatedArticles
                }),
                bottomCtas.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomCta, {
                    ctas: bottomCtas
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Drawer, {
                    show: showDrawer,
                    toggleDrawer: this.toggleDrawer
                })
            ]
        });
    };
    return ArticlePage;
}(react.Component);
var __N_SSG = true;
/* harmony default export */ var _slug_ = (ArticlePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [683,631,328,774,888,179], function() { return __webpack_exec__(88680); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);